module.exports = __webpack_public_path__ + "img/36_7.5520ec1a.png";